import api from './api';

export const getAnnouncement = () => api.get('/hub-announcement').then(r => r.data);

export const getRecentAnnouncements = () =>
  api.get('/hub-announcement/recent').then(r => r.data.announcements);

export const getAnnouncementById = (id) =>
  api.get(`/hub-announcement/${id}`).then(r => r.data);

export const getAnnouncementArchive = () =>
  api.get('/hub-announcement/archive').then(r => r.data.announcements);

export const searchAnnouncements = (q) =>
  api.get(`/hub-announcement/search?q=${encodeURIComponent(q)}`).then(r => r.data.announcements);
